import { render } from "./CardFeed.vue?vue&type=template&id=9b156fec&scoped=true&ts=true"
import script from "./CardFeed.vue?vue&type=script&lang=ts"
export * from "./CardFeed.vue?vue&type=script&lang=ts"

import "./CardFeed.vue?vue&type=style&index=0&id=9b156fec&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b156fec"]])

export default __exports__